import React from 'react';
import PropTypes from 'prop-types';
import TestResultCard from './TestResultCard';

function TestResultsSection({ testResults, getStatusColor, getStatusIcon }) {
  return (
    <div className="results-section">
      <h3>🔬 Detailed Test Results</h3>
      <div className="results-grid">
        {testResults.map((result, index) => (
          <TestResultCard
            key={index}
            result={result}
            getStatusColor={getStatusColor}
            getStatusIcon={getStatusIcon}
          />
        ))}
      </div>
    </div>
  );
}

TestResultsSection.propTypes = {
  testResults: PropTypes.array.isRequired,
  getStatusColor: PropTypes.func.isRequired,
  getStatusIcon: PropTypes.func.isRequired,
};

export default TestResultsSection;